<template>
  <div class="px-4">
    <div v-if="isOnline && isSurfaceKbEnabled">
      <div v-show="false">
        {{ startConversation() }}
      </div>
    </div>
    <div v-else>
    <div
      class="flex items-center justify-between mb-4"
      v-if="hasFetchedAvailableAgents"
    >
      <div class="text-black-700">
        <div
          class="text-base leading-5 font-medium mb-1 availability-message-wrapper"
          v-if="isOnline"
        >
          {{ avilabilityMessage }}
          <div
            v-if="isBotOnlineMessage"
            class="status-view--badge rounded-full leading-4 bg-green-500"
          ></div>
        </div>
        <div class="text-base leading-5 font-medium mb-1" v-else>
          {{
            outOfOfficeMessage
              ? outOfOfficeMessage
              : $t('TEAM_AVAILABILITY.OFFLINE')
          }}
        </div>
      </div>
      <available-agents v-if="isOnline" :agents="availableAgents" />
    </div>
    <div v-else class="flex items-center justify-center mb-2">
      <spinner size="small" />
    </div>
    <hiver-branding />
    <custom-button
      v-if="isOnline"
      class="font-medium send-message-mail-button"
      block
      :bg-color="widgetColor"
      :text-color="textColor"
      @click="startConversation"
    >
      {{ $t('START_CONVERSATION') }}
      <img :src="sendMessageArrowIcon" alt="Send Icon"/>
    </custom-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getContrastingTextColor } from '@chatwoot/utils';
import AvailableAgents from 'widget/components/AvailableAgents.vue';
import CustomButton from 'shared/components/Button';
import HiverBranding from 'widget/components/HiverBranding.vue';
import configMixin from 'widget/mixins/configMixin';
import availabilityMixin from 'widget/mixins/availability';
import Spinner from 'shared/components/Spinner.vue';
import { playCustomAudio } from 'shared/helpers/AudioNotificationHelper';
import sendMessageArrowIcon from '../assets/images/sendMessageArrowIcon.svg';

export default {
  name: 'TeamAvailability',
  components: {
    AvailableAgents,
    CustomButton,
    Spinner,
    HiverBranding,
  },
  mixins: [configMixin, availabilityMixin],
  props: {
    availableAgents: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      chatAvailabilityRequestInProgress: false,
      sendMessageArrowIcon,
    };
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
      outOfOfficeMessage: 'appConfig/getOutOfOfficeMessage',
      hasFetchedAvailableAgents: 'agent/getHasFetched',
      webChannelConfig: 'appConfig/getWebChannelConfig',
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
    isOnline() {
      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0;

      if (workingHoursEnabled ) {
        return (anyAgentOnline && this.isInBetweenTheWorkingHours) || this.hasAConnectedAgentBot;
      }
      return anyAgentOnline || this.hasAConnectedAgentBot;
    },
    replyWaitMeessage() {
      const { workingHoursEnabled } = this.channelConfig;

      if (this.isOnline) {
        return this.replyTimeStatus;
      }
      if (workingHoursEnabled) {
        return this.outOfOfficeMessage;
      }
      return '';
    },
    isBotOnlineMessage() {
      return this.hasAConnectedAgentBot && !this.availableAgents?.length > 0;
    },
    avilabilityMessage() {
      if (this.isBotOnlineMessage) {
        const { hasAConnectedAgentBot: botName } = this.channelConfig;
        return `${this.$t('TEAM_AVAILABILITY.TALK_TO_BOT')} ${botName}`;
      }

      return this.$t('TEAM_AVAILABILITY.ONLINE');
    },
    isSurfaceKbEnabled() {
      return this.isSurfaceKBInLiveChatEnabled;
    },
  },
  mounted() {
    if (this.isOnline && this.isSurfaceKbEnabled) {
      this.startConversation();
    }
  },
  methods: {
    ...mapActions('agent', ['fetchAvailableAgents']),
    ...mapActions('hiverConfig', ['fetchHiverConfig']),
    async startConversation() {
      if (this.chatAvailabilityRequestInProgress) {
        return;
      }
      if (!this.hasAConnectedAgentBot) {
        this.chatAvailabilityRequestInProgress = true;
        this.chatAvailabilityRequestInProgress = false;
      }

      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0 || this.hasAConnectedAgentBot;
      if ((!workingHoursEnabled && anyAgentOnline) || (workingHoursEnabled && this.isInBetweenTheWorkingHours && anyAgentOnline) || this.hasAConnectedAgentBot) {
        this.$emit('start-conversation');
        !this.isNotificationSoundDisabled && playCustomAudio('silence.mp3');
      }
    },
  },
};
</script>